<template>
  <div id="app">
     <router-view name="header" :key="key"></router-view>

     <router-view></router-view> <!--container部分-->

     <router-view name="footer"></router-view>
  </div>
</template>

<script>
  export default {
    data(){
      return{
      }
    },
    computed:{
      key(){
        return this.$route.name !==undefined ? this.$route.name+new Date():this.$route+new Date();
      },

    },
  }
</script>




// WEBPACK FOOTER //
// App.vue?0e893c5a